import store from "../store";
import { actionTypes } from "./saga";

/**
 * @module ComplaintsSaga
 */

/**
 *
 * @param {data} payload
 */
export function putComplaintsData(data, filters) {
  store.dispatch({
    type: actionTypes.PUT_COMPLAINTS_DATA,
    payload: {
      data: data,
      filters: filters
    }
  });
}

/**
 *
 * @param {data} payload
 */
export function getAllComplaintsCount(data) {
  store.dispatch({
    type: actionTypes.GET_ALL_COMPLAINTS_COUNTS,
    payload: data
  });
}

export function setComplaintsExportLoading(data) {
  store.dispatch({
    type: actionTypes.PUT_COMPLAINTS_EXPORT_LOADING,
    payload: { loading: data }
  });
}

/**
 *
 * @param {compliantData} payload
 */
export function verifyCompliant(documentId, type) {
  store.dispatch({
    type: actionTypes.VERIFY_COMPLAINT,
    payload: {
      documentId: documentId,
      type: type
    }
  });
}

// /**
//  *
//  * @param {data} payload
//  */
// export function getComplaintsAssets(locationId, selectedComplaint) {
//   store.dispatch({
//     type: actionTypes.GET_COMPLAINTS_ASSETS,
//     payload: {
//       locationId: locationId,
//       selectedComplaint: selectedComplaint,
//     },
//   });
// }

/**
 *
 *
 */
export function getTotalComplaints(data) {
  store.dispatch({
    type: actionTypes.GET_TOTAL_VALUES,
    payload: {
      data: data
    }
  });
}

/**
 *
 * @param {data} payload complains data
 */
export function fixComplaints(complaintId, locationId, proof, verify) {
  store.dispatch({
    type: actionTypes.FIX_COMPLAINTS,
    payload: {
      complaintId: complaintId,
      locationId: locationId,
      proof: proof,
      verify: verify
    }
  });
}

export function complaintTakeover(complaintId) {
  store.dispatch({
    type: actionTypes.COMPLAINT_TAKEOVER,
    payload: {
      complaintId: complaintId
    }
  });
}

export function setSelectedComplaint(complaintId, navigate) {
  store.dispatch({
    type: actionTypes.SET_SELECTED_COMPLAINT,
    payload: {
      complaintId,
      navigate
    }
  });
}

export function getTodayComplaintCount() {
  store.dispatch({
    type: actionTypes.GET_TODAY_COMPLAINT_COUNT
  });
}
